enum IconVariant {
  STUDENT = 'STUDENT',
  COACH = 'COACH',
}

export default IconVariant;
